/**
 * Created by Vladislav on 03.09.2026
 */

CupsConfig.TYPE_CLAN = "clan";
CupsConfig.TYPE_CLAN_INNER = "claninner";

// the clan cup is retired - uncomment to bring it back
// CupsConfig.TYPES[CupsConfig.TYPE_CLAN] = {
//     scenes: [cleverapps.Environment.SCENE_MAIN],
//     rewards: RewardsConfig.ClanCup,
//     origin: new Date("2022-10-06T00:00:00+00:00").getTime(),
//     duration: cleverapps.parseInterval("4 days"),
//     cooldown: cleverapps.parseInterval("10 days"),
//     restartAfter: cleverapps.parseInterval("1 day"),
//     participateAsClan: true,
//     topLimit: 50
// };
//
// if (cleverapps.config.debugMode || typeof cc === "undefined" && process.env.NODE_ENV !== "production") {
//     CupsConfig.TYPES[CupsConfig.TYPE_CLAN].duration = cleverapps.parseInterval("4 minutes");
//     CupsConfig.TYPES[CupsConfig.TYPE_CLAN].cooldown = cleverapps.parseInterval("1 minute");
//     CupsConfig.TYPES[CupsConfig.TYPE_CLAN].restartAfter = cleverapps.parseInterval("30 seconds");
// }
//
// CupsConfig.TYPES[CupsConfig.TYPE_CLAN_INNER] = {
//     ...CupsConfig.TYPES[CupsConfig.TYPE_CLAN],
//     master: CupsConfig.TYPE_CLAN,
//     rewards: [],
//     participateAsClan: false,
//     topLimit: 50
// };

RewardTypes.cup.icon[CupsConfig.TYPE_CLAN] = bundles.reward_icons.frames.cup_png;
RewardTypes.cup.smallIcon[CupsConfig.TYPE_CLAN] = bundles.reward_icons.frames.cup_small_png;
